import { useTranslation } from 'react-i18next';

interface Props {
  descricao: string;
  quando: string;
  onde: string;
  envolvidos: string;
  onChange: (
    data: Partial<{ descricao: string; quando: string; onde: string; envolvidos: string }>,
  ) => void;
}

const MIN_CHARS = 50;

export function Step2Fato({ descricao, quando, onde, envolvidos, onChange }: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="fade-in">
      <h2>{t('wizard.step2_title')}</h2>

      <div className="form-group" style={{ marginTop: 16 }}>
        <label className="form-label" htmlFor="descricao">
          {t('step2.descricao_label')} *
        </label>
        <textarea
          id="descricao"
          className="form-textarea"
          rows={6}
          value={descricao}
          onChange={(e) => onChange({ descricao: e.target.value })}
          placeholder={t('step2.descricao_placeholder')}
          aria-required="true"
        />
        <p className={`char-counter ${descricao.length >= MIN_CHARS ? '' : 'insufficient'}`}>
          {descricao.length} / {t('step2.min_chars', { min: String(MIN_CHARS) })}
        </p>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="quando">
          {t('step2.when_label')}
        </label>
        <input
          id="quando"
          className="form-input"
          type="text"
          value={quando}
          onChange={(e) => onChange({ quando: e.target.value })}
        />
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="onde">
          {t('step2.where_label')}
        </label>
        <input
          id="onde"
          className="form-input"
          type="text"
          value={onde}
          onChange={(e) => onChange({ onde: e.target.value })}
        />
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="envolvidos">
          {t('step2.who_label')}
        </label>
        <input
          id="envolvidos"
          className="form-input"
          type="text"
          value={envolvidos}
          onChange={(e) => onChange({ envolvidos: e.target.value })}
        />
      </div>
    </div>
  );
}
